import { Controller } from "@hotwired/stimulus"
import ouibounce from "ouibounce"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.ouibounceInstance = ouibounce(document.body, {
      aggressive: true,
      callback: () => this.openModal()
    })
  }

  disconnect() {
    if (this.ouibounceInstance) {
      this.ouibounceInstance.disable()
    }
  }

  openModal() {
    if (!this.hasModalTarget) return
    const modalElement = this.modalTarget.firstElementChild || this.modalTarget
    modalElement.dispatchEvent(new CustomEvent("demo-modal:open"))
  }
}
